// Utilidades de formato — hora local de Tijuana (Pacífico de México).
// UI-01B · HORARIO DE 24 HORAS en toda la consola. `es-MX` por defecto rinde "02:35 p.m.", lo que
// discrepaba de la cola, el reloj y el Radar (que ya pedían hour12:false). Sólo cambia la
// PRESENTACIÓN: no se tocan timestamps almacenados, ni la zona, ni las fechas mostradas.
const TZ = "America/Tijuana";

// Fecha capturada como 'YYYY-MM-DD' (sin conversión de zona horaria).
export function fmtFecha(str) {
  if (!str) return "—";
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(str);
  if (!m) return str;
  return `${m[3]}/${m[2]}/${m[1]}`;
}

// UI-011: variante CON SEGUNDOS para listas cronológicas donde dos registros del mismo tipo y
// persona pueden caer en el mismo minuto (Bitácora). Usa el dato que ya trae la respuesta.
export function fmtTimestampSeg(iso) {
  if (!iso) return "—";
  try {
    return new Intl.DateTimeFormat("es-MX", {
      timeZone: TZ, day: "2-digit", month: "2-digit", year: "numeric",
      hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false,
    }).format(new Date(iso));
  } catch {
    return iso;
  }
}

// Timestamp ISO (UTC) -> fecha y hora local de Tijuana.
export function fmtTimestamp(iso) {
  if (!iso) return "—";
  try {
    return new Intl.DateTimeFormat("es-MX", {
      timeZone: TZ,
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    }).format(new Date(iso));
  } catch {
    return iso;
  }
}

// GC92 · HORA DE OPERACIÓN = America/Tijuana SIEMPRE, con independencia del huso del teléfono o
// del portátil que consulta. `toLocaleTimeString` sin `timeZone` rendía la hora del dispositivo.
export function fmtHoraCorta(iso) {
  if (!iso) return "";
  try {
    return new Intl.DateTimeFormat("es-MX", {
      timeZone: TZ, hour: "2-digit", minute: "2-digit", hour12: false,
    }).format(new Date(iso));
  } catch {
    return "";
  }
}

// Día local de Tijuana en formato AAAA-MM-DD (sirve para comparar «hoy» cruzando la medianoche).
export function diaTijuana(iso) {
  try {
    const d = iso ? new Date(iso) : new Date();
    if (Number.isNaN(d.getTime())) return "";
    const p = new Intl.DateTimeFormat("en-CA", {
      timeZone: TZ, year: "numeric", month: "2-digit", day: "2-digit",
    }).formatToParts(d).reduce((a, x) => ({ ...a, [x.type]: x.value }), {});
    return `${p.year}-${p.month}-${p.day}`;
  } catch {
    return "";
  }
}

export const esHoyTijuana = (iso) => !!iso && diaTijuana(iso) === diaTijuana();

export function calcEdad(fechaNac) {
  if (!fechaNac) return null;
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(fechaNac);
  if (!m) return null;
  const nac = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  const hoy = new Date();
  let edad = hoy.getFullYear() - nac.getFullYear();
  const md = hoy.getMonth() - nac.getMonth();
  if (md < 0 || (md === 0 && hoy.getDate() < nac.getDate())) edad--;
  return edad;
}

export function boolLabel(v) {
  if (v === true) return "Sí";
  if (v === false) return "No";
  return "Sin contestar";
}
